<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint"> <i class="fa fa-print" aria-hidden="true"></i> In </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button v-if="showPrice" block variant="success" @click="showPrice = !showPrice">
          <i class="fa fa-eye-slash" aria-hidden="true"></i>
          Ẩn giá
        </b-button>
        <b-button v-else block variant="success" @click="showPrice = !showPrice">
          <i class="fa fa-eye" aria-hidden="true"></i>
          Hiển thị giá
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print" class="print-box mt-3 mb-3" style="padding-top:25px">
        <div class="d-flex" style="justify-content:center">
          <div class="header text-center">
            <h3>LỆNH CHẾ TẠO</h3>
          </div>
          <table class="prtable prtable-bordered" style="margin-left:50px; width:250px">
            <tr>
              <td colspan="3">Yêu cầu khách hàng</td>
            </tr>
            <tr>
              <td>Rất khó</td>
              <td>Khó</td>
              <td>Bình thường</td>
            </tr>
            <tr>
              <td>
                <i class="fa" v-if="manufacture.level == 3"><b>V</b></i>
              </td>
              <td>
                <i class="fa" v-if="manufacture.level == 1"><b>V</b></i>
              </td>
              <td>
                <i class="fa" v-if="manufacture.level == 2"><b>V</b></i>
              </td>
            </tr>
          </table>
        </div>
        <div class="info" style="margin-bottom:4px">
          <table class="prtable">
            <tr>
              <td>Mã khách hàng : {{ manufacture.customer.code }}</td>
              <td>
                Ngày giao hàng :
                <span v-if="manufacture.order && manufacture.order.id">
                  {{ $date(manufacture.dateDelivery) }}
                </span>
                <span v-else>
                  0
                </span>
              </td>
            </tr>
            <tr>
              <td style="min-width: 120px">Ngày, tháng : {{ $date(manufacture.date) }}</td>
              <td>
                Mã đơn hàng :
                <span v-if="manufacture.order && manufacture.order.id">
                  {{ manufacture.order.code }}
                </span>
                <span v-else>
                  0
                </span>
              </td>
              <td>
                <strong style="white-space:nowrap">Mã lệnh chế tạo : {{ manufacture.code }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <table class="prtable" style="margin-top:5px">
                  <tr>
                    <td colspan="4">
                      <table class="prtable">
                        <td>
                          <div style="white-space:nowrap">
                            Mã sản phẩm: <b>{{ manufacture.product.code }}</b>
                          </div>
                        </td>
                        <td>
                          Tên sản phẩm: <b>{{ manufacture.product.name }}</b>
                          <!-- <b v-if="manufacture.productCustom && manufacture.productCustom.length>0"> - {{ manufacture.productCustom }}</b> -->
                          <b v-if="manufacture.reason"> - {{ manufacture.reason.name }}</b>
                        </td>
                        <td>
                          <div style="white-space:nowrap">
                            Quy cách: <b>{{ manufacture.productSpecify.name }} mm</b>
                          </div>
                        </td>
                        <td>
                          <div style="white-space:nowrap">
                            Chiều dài: <b>{{ manufacture.length }} CM</b>
                          </div>
                          <!-- {{ manufacture.unit }} -->
                        </td>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td style="text-align:left;">
                      Hệ màu: <b>{{ manufacture.color.label }}</b>
                    </td> -->
                    <td style="text-align:left;">
                      Màu sắc: <b>{{ manufacture.colorText }}</b>
                    </td>
                    <td>
                      Mã màu 1: <b>{{ manufacture.colorCode1 }}</b>
                    </td>
                    <td>
                      Mã màu 2: <b>{{ manufacture.colorCode2 }}</b>
                    </td>
                    <td>Co giãn: {{ manufacture.elastic }}</td>
                  </tr>
                  <!-- <tr>
                    <td style="text-align:left;">
                      Định mức/Y: {{ manufacture.quotaY }} g
                    </td>
                    <td style="text-align:left;">
                      Y/Kg: {{ manufacture.yKg }}
                    </td>
                    <td style="text-align:left;">
                      Định mức/M: {{ manufacture.quotaM }} g
                    </td>
                    <td style="text-align:left;">
                      M/kg: {{ manufacture.mKg }}
                    </td>
                  </tr> -->
                </table>
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td colspan="2"></td>
            </tr>
            <tr>
              <td colspan="4">
                <table class="prtable" style="margin-top:0px">
                  <tr>
                    <td>
                      Số lượng đặt: {{ manufacture.quantityOrder }}
                      {{ manufacture.unit }}
                    </td>
                    <td>
                      Số lượng tồn:
                      <span v-if="manufacture.product && manufacture.product.info">{{
                        manufacture.product.info.quantity
                      }}</span>
                      {{ manufacture.unit }}
                    </td>
                    <td>
                      Số lượng dệt: {{ manufacture.quantityInventory }} M
                      <!-- {{ manufacture.unit }} -->
                    </td>
                    <!-- <td>Định mức : {{ manufacture.quota }}</td> -->
                    <td>Định mức : {{ manufacture.productSpecify.quota }} G/M</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="process" style="margin-bottom:4px">
          <table class="prtable prtable-bordered">
            <tr>
              <td>Cone chỉ</td>
              <td>Đánh trục</td>
              <td>Dệt</td>
              <td>Quấn bó/ống</td>
              <td>Nhuộm sau</td>
              <td>Định hình dây</td>
              <td>Cắt</td>
              <td>Gia công mặt dây</td>
              <td>Gia công đầu dây</td>
              <td>Kiểm phẩm</td>
              <td>Nhập kho</td>
            </tr>
            <tr>
              <td>
                <i class="" v-if="manufacture.process.cone_chi == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.danh_truc == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.det == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.quan_bo == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.nhuom_sau == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.can_nhiet_ho == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.cat == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.bam_dau_keo == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.bam_dau_dong == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.kiem_pham == true"><b>V</b></i>
              </td>
              <td>
                <i class="" v-if="manufacture.process.nhap_kho == true"><b>V</b></i>
              </td>
            </tr>
          </table>
        </div>
        <div class="data">
          <table class="prtable" style="font-family: 'Helvetica', 'Arial', sans-serif">
            <thead>
              <tr style="border-top:1px solid;border-bottom:1px solid;">
                <th style="font-size:10px; padding:0px 5px">STT</th>
                <th style="font-size:9px; padding:0px 5px">Công dụng</th>
                <th style="font-size:9px; padding:0px 5px">Nguyên liệu</th>
                <th style="font-size:10px; padding:0px 5px">Quy cách</th>
                <th style="font-size:9px; padding:0px 5px">Màu sắc</th>
                <th style="font-size:9px; padding:0px 5px">Mã màu 1</th>
                <th style="font-size:9px; padding:0px 5px">Mã màu 2</th>
                <th style="font-size:10px; padding:0px 5px">Số lượng</th>
                <th style="font-size:10px; padding:0px 5px">% Sợi</th>
                <th style="font-size:10px; padding:0px 5px;line-height:15px; text-align:center">
                  Trọng lượng<br />
                  <i>(KG)</i>
                </th>
                <th style="font-size:10px; padding:0px 5px">% Hao hụt</th>
                <th style="font-size:10px; padding:0px 5px; line-height:15px; text-align:center">
                  Tổng trọng lượng<br />
                  <i>(KG)</i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productFeatures" :key="index">
                <td style="text-align:center">{{ index + 1 }}</td>
                <td style="font-size:10px;">{{ item.deportment }}</td>
                <td style="text-align:center;font-size:10px;">{{ item.material }}</td>
                <td style="text-align:center">{{ item.spec }}</td>
                <td style="text-align:center; font-size:9px;">
                  <span v-if="item.color">{{ item.color.label }}</span>
                </td>
                <td style="text-align:center;font-size:9px;">{{ item.colorCode1 }}</td>
                <td style="text-align:center;font-size:9px;">{{ item.colorCode2 }}</td>
                <td style="text-align:center;font-size:13px;">{{ item.quantity }}</td>
                <td style="text-align:right;font-size:13px;">{{ item.percentYarn }} %</td>
                <td style="text-align:right;font-size:13px;">{{ $formatNumber(item.weight) }} kg</td>
                <td style="text-align:right">{{ item.percentLoss }} %</td>
                <td style="text-align:right;font-size:13px;">{{ $formatNumber(item.total_weight) }} kg</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="7">Tổng cộng</th>
                <th colspan="2" style="text-align:right;font-size:13px;">{{ $formatNumber(summary.percentYarn) }} %</th>
                <th style="text-align:right;font-size:13px;">{{ $formatNumber(summary.weight) }} Kg</th>
                <th></th>
                <th style="text-align:right;font-size:13px;">{{ $formatNumber(summary.total_weight) }} Kg</th>
              </tr>
            </tfoot>
          </table>
          <hr style="margin-top:10px; margin-bottom:5px" />
          <strong>Ghi chú:</strong>
          <table class="prtable">
            <tr v-for="(item, index) in productParameters" :key="index">
              <!-- <td style="text-align:center; width: 30px;">#{{ index + 1 }}</td> -->
              <td style="border: none;">
                <div v-html="item.col1"></div>
              </td>
              <!-- <td style="border: none;">
                <div v-html="item.col2"></div>
              </td>
              <td style="border: none;">
                <div v-html="item.col3"></div>
              </td>
              <td style="border: none;">
                <div v-html="item.col4"></div>
              </td> -->
              <!-- <td style="border: none;">#/</td>
              <td style="border: none;">{{ item.col1 }}</td>
              <td style="border: none;">{{ item.col2 }}</td>
              <td style="border: none;">{{ item.col3 }}</td>
              <td style="border: none;">{{ item.col4 }}</td> -->
            </tr>
          </table>
        </div>
        <div class="footer">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <!-- <table class="prtable">
                  <tr>
                    <td style="border-bottom: 1px dotted;">
                      Ghi chú :
                      <p
                        class="print-note"
                        style="display:inline-block; margin:0"
                        v-html="manufacture.note"
                      ></p>
                    </td>
                  </tr>
                </table> -->
              </td>
            </tr>
            <tr>
              <td class="text-left" style="vertical-align: top; width:50%"></td>
              <td class="text-center" style="vertical-align: top; width:50%">
                <h5>Lập biểu</h5>
                <br />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
export default {
  props: {},
  data() {
    return {
      visible: false,
      showPrice: true,
      manufacture: {
        id: '',
        level: 0,
        process: '',
        customer: {},
        product: {},
        productSpecify: {},
        color: {}
      },
      summary: {
        percentYarn: 0,
        weight: 0,
        total_weight: 0
      },
      productFeatures: [],
      productParameters: []
    };
  },
  methods: {
    setData(manufacture, productFeatures, productParameters) {
      this.manufacture = manufacture;
      try {
        this.manufacture.process = JSON.parse(manufacture.processJson);
      } catch (error) {
        this.manufacture.process = {
          cone_chi: true,
          danh_truc: false,
          det: true,
          quan_bo: false,
          nhuom_sau: false,
          can_nhiet_ho: false,
          cat: false,
          bam_dau_keo: true,
          bam_dau_dong: false,
          kiem_pham: true,
          nhap_kho: true
        };
      }

      this.productParameters = productParameters;
      this.productFeatures = productFeatures;

      this.summary = {
        percentYarn: 0,
        weight: 0,
        total_weight: 0
      };

      productFeatures.forEach(element => {
        this.summary.percentYarn += Number(element.percentYarn);
        this.summary.weight += Number(element.weight);
        this.summary.total_weight += Number(element.total_weight);
      });

      // productOrders.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productOrders.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print('print');
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit('doSave', () => {
        this.order.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
